/* @flow */
import produce from 'immer';
import { actionTypes } from './actions';

const {
  TOGGLE_UAPI_IFRAME_MODAL,
  TOGGLE_INVITE_USER_MODAL,
  TOGGLE_PROPOSALS_FORM_MODAL,
  TOGGLE_EDIT_PROPOSALS_TABLE_MODAL,
  TOGGLE_UPLOAD_RESOURCE_MODAL,
  TOGGLE_GENERATE_PROPOSAL_MODAL,
  TOGGLE_VIEW_PROPOSAL_INPUTS_MODAL,
  TOGGLE_UPLOAD_BULK_ENRICHMENT_FILE_MODAL,
  TOGGLE_UPLOAD_PROSPECT_BULK_ENRICHMENT_FILE_MODAL,
  TOGGLE_PRIVACY_POLICY_MODAL,
  TOGGLE_TERMS_OF_SERVICE_MODAL,
  TOGGLE_QUOTES_MODAL,
  TOGGLE_PLATFORM_AGREEMENTS_MODAL,
} = actionTypes;

type State = {
  isUAPIIframeModalOpen: boolean,
  isInviteUserModalOpen: boolean,
  isProposalsFormModalOpen: boolean,
  isEditProposalsTableModalOpen: boolean,
  isUploadResourceModalOpen: boolean,
  isGenerateProposalModalOpen: boolean,
  isViewProposalInputsModalOpen: boolean,
  isUploadBulkEnrichmentFileModalOpen: boolean,
  isUploadProspectBulkEnrichmentFileModalOpen: boolean,
  isPrivacyPolicyModalOpen: boolean,
  isTermsOfServiceModalOpen: boolean,
  isQuotesModalOpen: boolean,
  isPlatformAgreementsModalOpen: boolean,
};

const initialState = {
  isUAPIIframeModalOpen: false,
  isInviteUserModalOpen: false,
  isProposalsFormModalOpen: false,
  isEditProposalsTableModalOpen: false,
  isUploadResourceModalOpen: false,
  isGenerateProposalModalOpen: false,
  isViewProposalInputsModalOpen: false,
  isUploadBulkEnrichmentFileModalOpen: false,
  isUploadProspectBulkEnrichmentFileModalOpen: false,
  isPrivacyPolicyModalOpen: false,
  isTermsOfServiceModalOpen: false,
  isQuotesModalOpen: false,
  isPlatformAgreementsModalOpen: false,
};

export default (state: State = initialState, action: ActionT = {}): State =>
  produce(state, (draft) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case TOGGLE_UAPI_IFRAME_MODAL:
        draft.isUAPIIframeModalOpen = action.payload;
        return;
      case TOGGLE_INVITE_USER_MODAL:
        draft.isInviteUserModalOpen = action.payload;
        return;
      case TOGGLE_EDIT_PROPOSALS_TABLE_MODAL:
        draft.isEditProposalsTableModalOpen = action.payload;
        return;
      case TOGGLE_PROPOSALS_FORM_MODAL:
        draft.isProposalsFormModalOpen = action.payload;
        return;
      case TOGGLE_UPLOAD_RESOURCE_MODAL:
        draft.isUploadResourceModalOpen = action.payload;
        return;
      case TOGGLE_GENERATE_PROPOSAL_MODAL:
        draft.isGenerateProposalModalOpen = action.payload;
        return;
      case TOGGLE_VIEW_PROPOSAL_INPUTS_MODAL:
        draft.isViewProposalInputsModalOpen = action.payload;
        return;
      case TOGGLE_UPLOAD_BULK_ENRICHMENT_FILE_MODAL:
        draft.isUploadBulkEnrichmentFileModalOpen = action.payload;
        return;
      case TOGGLE_UPLOAD_PROSPECT_BULK_ENRICHMENT_FILE_MODAL:
        draft.isUploadProspectBulkEnrichmentFileModalOpen = action.payload;
        return;
      case TOGGLE_PRIVACY_POLICY_MODAL:
        draft.isPrivacyPolicyModalOpen = action.payload;
        return;
      case TOGGLE_TERMS_OF_SERVICE_MODAL:
        draft.isTermsOfServiceModalOpen = action.payload;
        return;
      case TOGGLE_QUOTES_MODAL:
        draft.isQuotesModalOpen = action.payload;
        return;
      case TOGGLE_PLATFORM_AGREEMENTS_MODAL:
        draft.isPlatformAgreementsModalOpen = action.payload;
        return;
    }
  });
